module.exports = __webpack_public_path__ + "img/doctor-with-patient.551adec3.jpg";